/** Check if a font family exists on Google Fonts. Returns true if valid. */
export async function validateGoogleFont(family: string): Promise<boolean> {
  if (!family.trim()) return true;
  try {
    const url = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family)}&display=swap`;
    const res = await fetch(url, { method: 'HEAD' });
    return res.ok;
  } catch {
    return false;
  }
}
